module.exports = __webpack_public_path__ + "img/6_32.f91bb842.png";